export default {
  关于我们: 'About Us',
  平台服务: 'Platform Services',
  云采购: 'Cloud Sourcing',
  公司概况: 'Company Overview',
  联系我们: 'Contact Us',
  新手指南: 'New User Tutorial',
  隐私权政策: 'Privacy Policy',
  公告: 'Notice',
  平台公告: 'Notice',
  法律声明及隐私权政策: 'Legal Notice and Privacy Policy',
  商务合作: 'Business Cooperation',
  免责声明: 'Disclaimer',
  '版权所有 (C) 广州智会云科技发展有限公司':
    '© Guangzhou Zhihuiyun Technology Development Co., Ltd. All rights reserved.',
  '本网站部分内容由用户自行上传,如权利人发现存在误传其作品情形,请及时与本站联系。':
    'Partial contents on this website are uploaded by users. If someone has infringed your copyright, please contact us.。',
  云展动力版权政策与法律说明: 'Copyright Policy and Legal Notice',
}
